export default { sha: '38a7d505629540863cab14b6abb94f831f31c8be', buildNumber: 'undefined' }
